// Auth-aware fetch wrapper for the dispatch UI.
//
// Session lives in an HttpOnly `dispatch_session` cookie set by the backend
// on /api/auth/login. The browser sends it automatically for same-origin
// requests. This helper only:
//   - Ensures every dispatch call is made with credentials:'include'
//   - Redirects to /dispatch/login on HTTP 401
//
// No token is ever read from JavaScript. localStorage is no longer used.

function handleUnauthorized() {
  if (typeof window === 'undefined') return;
  const { pathname, search } = window.location;
  if (pathname.startsWith('/dispatch/login')) return;
  const returnTo =
    pathname.startsWith('/dispatch/') ? `${pathname}${search || ''}` : '';
  const target = returnTo
    ? `/dispatch/login?returnTo=${encodeURIComponent(returnTo)}`
    : '/dispatch/login';
  window.location.replace(target);
}

/**
 * fetch() drop-in that automatically sends the session cookie and redirects
 * to /dispatch/login on HTTP 401.
 *
 *   const res = await authFetch('/api/dispatch/board');
 *   const res = await authFetch('/api/bookings/123', { method: 'PATCH', body });
 */
export async function authFetch(input, init = {}) {
  const headers = new Headers(init.headers || {});
  if (init.body && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }
  const url =
    typeof input === 'string' && input.startsWith('/')
      ? `${process.env.REACT_APP_BACKEND_URL}${input}`
      : input;
  const res = await fetch(url, {
    ...init,
    headers,
    credentials: 'include',
  });
  if (res.status === 401) {
    handleUnauthorized();
  }
  return res;
}

/** Manual logout: revokes the server session and clears the cookie. */
export async function logout() {
  try {
    await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/logout`, {
      method: 'POST',
      credentials: 'include',
    });
  } catch {
    /* ignore -- we still redirect */
  }
  if (typeof window !== 'undefined') {
    window.location.replace('/dispatch/login');
  }
}
